import GSAP from 'gsap';

import ImageHoverEffect from '../../components/@avery-image-hover-effect';
import AboutSection from './AboutSection';
import EyeRecorder from '../../components/EyeRecorder';
import EyePlayer from '../../components/EyePlayer';

import Page from '@averyano/core/src/classes/Page';

import each from 'lodash/each';
import SelectionTextSection from './SelectionTextSection';
import ProjectsSection from './ProjectsSection';
import WhoFeedbackSection from './WhoFeedbackSection';
import PricingSection from './PricingSection';
import FaqSection from './FaqSection';
import VisSection from './VisSection';
import ServicesSection from './ServicesSection';

export default class HomePage extends Page {
	constructor(el) {
		super({
			element: el,
			elements: {
				title: '.cover__title',
				list: 'li',
				desc: '.cover__desc--hidden',
				btn: '.btn',
			},
		});
		this.id = 'home';
		this.isCreated = false;
	}

	create() {
		if (this.template != this.id) return;

		if (!this.isReady) super.createComponent();

		if (!this.isCreated) {
			this.components = {
				// selection: new ImageHoverEffect({
				// 	element: '.who',
				// 	elements: {
				// 		figure: '.who__figure',
				// 		overlay: '.who__figure-overlay',
				// 		content: [
				// 			{
				// 				image: '#selection-designs',
				// 				button: '.who__item--des',
				// 			},
				// 			{
				// 				image: '#selection-websites',
				// 				button: '.who__item--dev',
				// 			},
				// 			{
				// 				image: '#selection-branding',
				// 				button: '.who__item--brand',
				// 			},
				// 		],
				// 	},
				// 	activeClass: 'who__image--active',
				// }),
				about: new AboutSection(),
				services: new ServicesSection(),
				projects: new ProjectsSection(),
				whoFeedback: new WhoFeedbackSection(),
				// selectionText: new SelectionTextSection(),
				pricing: new PricingSection(),
				faq: new FaqSection({ opened: false }),
				// vis: new VisSection(),
			};
			this.isCreated = true;
		}
		// Create components
		each(this.components, (component) => {
			component.create();
			if (component.addEventListeners) component.addEventListeners();
		});

		if (!this.eyeRecorder) {
			this.eyeRecorder = new EyeRecorder({
				aboutSection: this.components.about,
			});
		}
		if (!this.eyePlayer) {
			this.eyePlayer = new EyePlayer({ aboutSection: this.components.about });
		}

		console.log(`🔼 ${this.id} is created`);
	}

	show() {}

	hide() {
		return new Promise((resolve) => {
			this.destroy();

			GSAP.to(this.element, {
				autoAlpha: 0,
				onComplete: resolve,
			});
		});
	}

	onResize() {
		// if (this.element) this.element.style.height = `${window.innerHeight}px`;

		each(this.components, (component) => {
			if (component.onResize) component.onResize();
		});
	}

	addEventListeners() {
		each(this.components, (component) => {
			component.addEventListeners();
		});
	}

	removeEventListeners() {
		each(this.components, (component) => {
			component.removeEventListeners();
		});
	}

	destroy() {
		super.destroy();
		this.removeEventListeners();

		each(this.components, (component) => {
			component.destroy();
		});

		if (this.eyeRecorder) {
			this.eyeRecorder.destroy();
			this.eyeRecorder = null;
		}
		if (this.eyePlayer) {
			this.eyePlayer.destroy();
			this.eyePlayer = null;
		}

		// Removes scroll trigger instances
		const scrolltriggerElements = document.querySelectorAll('.pin-spacer');
		each(scrolltriggerElements, (pinSpacer) => {
			const parent = pinSpacer.parentElement;

			while (pinSpacer.firstChild) {
				parent.appendChild(pinSpacer.firstChild);
			}

			parent.removeChild(pinSpacer);
		});
	}

	update() {
		if (
			this.components &&
			this.components.selection &&
			this.components.selection.isReady
		)
			this.components.selection.update();

		if (this.components && this.components.about)
			this.components.about.update();

		if (this.eyeRecorder) this.eyeRecorder.update();
		if (this.eyePlayer) this.eyePlayer.update();
	}
}
